import apiClient from './apiConfig';

const settingsApi = {
  // Get global settings (discountRules, ...)
  getSettings: async () => {
    try {
      const response = await apiClient.get('/settings');
      return response.data;
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error;
    }
  },

  // Update global settings
  updateSettings: async (data) => {
    try {
      const response = await apiClient.put('/settings', data);
      return response.data;
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error;
    }
  },
};

export default settingsApi;
